import { getVitalsWithNamesParameters } from '@features/components/ClinicalData/components/ClinicalLog/components/vitals/utils';
import { VitalParameters } from '@/api/apis/case';

const Row = ({ name, value }: { name: string; value: string }) => {
  return (
    <div className="flex text-s-r">
      <div className="w-11 text-base-20">{name}</div>
      <div>{value}</div>
    </div>
  );
};

type VitalsDataTableProps = {
  vitalParameters?: VitalParameters;
};
export const VitalsDataTable = ({ vitalParameters }: VitalsDataTableProps) => {
  const vitalsWithNamesParameters = getVitalsWithNamesParameters(vitalParameters);
  return (
    <div className="flex flex-col gap-2">
      {vitalsWithNamesParameters.map(({ name, value }) => (
        <Row key={`${name}-${value}`} name={name} value={value} />
      ))}
    </div>
  );
};
